/**
 * @generated SignedSource<<4c812013d9da4495d4bec7983b7e4813>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersIsArchiveWallArticle$data = {
  readonly createdDate: number | null;
  readonly paywallTypes: ReadonlyArray<{
    readonly entityId: string;
  } | null> | null;
  readonly publishedDate: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"helpersIsVelocityWallArticle">;
  readonly " $fragmentType": "helpersIsArchiveWallArticle";
};
export type helpersIsArchiveWallArticle$key = {
  readonly " $data"?: helpersIsArchiveWallArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersIsArchiveWallArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersIsArchiveWallArticle"
};

(node as any).hash = "20759885009aa42a350d07349eaae9da";

export default node;
